import React, { useRef, useEffect, useState } from 'react';
import classNames from 'classnames';
import debounce from 'lodash/debounce';

const AnimateOnVisible = ({ children, className = '', onVisible }) => {
  const ref = useRef(null);
  const [ isVisible, setIsVisible ] = useState(false);

  useEffect(() => {
    const container = document.querySelector('.scroll-container');
    if (!container || !ref.current) {
      return;
    }

    const shift = 100;

    const checkVisibility = () => {
      const containerRect = container.getBoundingClientRect();
      const elRect = ref.current.getBoundingClientRect();

      if (!isVisible && elRect.top < containerRect.bottom + shift) {
        setIsVisible(true);
        onVisible && onVisible();
      }
    };

    const handleScroll = debounce(checkVisibility, 10);

    const timeout = setTimeout(() => {
      checkVisibility(); // check on mount
    }, 300);

    container.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    return () => {
      container.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
      handleScroll.cancel?.();
      clearTimeout(timeout);
    };
  }, [ isVisible, onVisible ]);

  return (
    <div
      ref={ ref }
      className={ classNames(className, 'animate-slideup', {
        '-is-visible': isVisible
      }) }
    >
      { children }
    </div>
  );
};

export default AnimateOnVisible;
